import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownButton, Form } from 'react-bootstrap';
import { map } from 'lodash';

const LOCATION_FILTER_NAME = 'location';
const TAGS_FILTER_NAME = 'tags';

const ButtonFilter = ({ filterOptions }) => {
  const sortedFilters = map(filterOptions);
  return (
    <DropdownButton className="d-inline" id="filter" variant="light" title="Filter By" alignRight>
      {map(sortedFilters, ({ filterOn, humanValue, name, changeFilterOn }, index, array) => {
        const addTypeHeader = name === LOCATION_FILTER_NAME && index < array.length - 1;
        if (name === TAGS_FILTER_NAME) return '';
        return (
          <React.Fragment key={name}>
            <Dropdown.Item eventKey={name} onClick={e => e.stopPropagation()}>
              <Form.Check
                id={name}
                checked={filterOn}
                onClick={e => e.stopPropagation()}
                onChange={event => changeFilterOn(event.target.checked)}
                label={humanValue}
              />
            </Dropdown.Item>
            {addTypeHeader && <Dropdown.Header>Type</Dropdown.Header>}
          </React.Fragment>
        );
      })}
    </DropdownButton>
  );
};

ButtonFilter.propTypes = {
  filterOptions: PropTypes.object.isRequired
};

export default ButtonFilter;
